<template>
    <div class="secondary-c">
        <edit-input :label="$t('fields.username')" icon="fa fa-tag">
            <form-input v-model="profile_settings.username" name="username" type="text"></form-input>
        </edit-input>

        <edit-input :label="$t('profile.change_password')" icon="fa fa-key">
            <div class="ghost-button" @click="emitTabChange">{{ $t('profile.change_password') }}</div>
        </edit-input>

        <div class="tw-flex">
            <edit-input class="tw-mr-4 tw-w-full" :label="$t('fields.firstname')" icon="fa fa-user">
                <form-input v-model="profile_settings.firstname" name="firstname" type="text"></form-input>
            </edit-input>
            <edit-input class="tw-w-full" :label="$t('fields.lastname')" icon="fa fa-user">
                <form-input v-model="profile_settings.lastname" name="lastname" type="text"></form-input>
            </edit-input>
        </div>

        <edit-input class="tw-mr-4 tw-w-full" :label="$t('profile.gender')" icon="fa fa-user">
            <form-select v-model="profile_settings.gender" :options="gender_options" name_clean="name_clean"
                display_name="name"></form-select>
        </edit-input>

        <edit-input class="tw-mr-4 tw-w-full" :label="$t('fields.email')" icon="fa fa-envelope">
            <form-input v-model="profile_settings.email" name="email" type="email"></form-input>
        </edit-input>

	    <div class="tw-rounded tw-bg-orange-400 tw-p-3 tw-shadow tw-mb-7" v-if="profile_settings.email_change">
		    <p class="tw-leading-relaxed tw-text-sm">
			    <i class="fa fa-exclamation-triangle tw-pr-1 tw-pt-1"></i>
			    {{ $t('profile.change_email_send_to') }}
			    {{ profile_settings.email_change.email }}.
			    {{ $t('profile.click_link_to_change_email') }}
		    </p>
	    </div>

        <edit-input class="tw-mr-4 tw-w-full" :label="$t('fields.phone')" icon="fa fa-phone">
            <form-input v-model="profile_settings.profile.phone" name="phone" type="tel"></form-input>
        </edit-input>

        <edit-input class="tw-mr-4 tw-w-full" :label="$t('profile.complete_birth_date')" icon="fa fa-birthday-cake">
            <form-input v-model="profile_settings.birth_date" name="birth_date" type="date"></form-input>
        </edit-input>

        <edit-input class="tw-mr-4 tw-w-full" :label="$t('fields.address')" icon="fa fa-home">
            <form-input v-model="profile_settings.profile.address" name="address" type="text"></form-input>
        </edit-input>

        <edit-input class="tw-mr-4 tw-w-full" :label="$t('fields.country')" icon="fa fa-globe">
            <form-input v-model="profile_settings.profile.country" name="country" type="text"></form-input>
        </edit-input>

        <edit-input class="tw-mr-4 tw-w-full" :label="$t('fields.zipcode')" icon="fa fa-map-marker">
            <form-input v-model="profile_settings.profile.zipcode" name="zipcode" type="text"></form-input>
        </edit-input>

        <edit-input class="tw-mr-4 tw-w-full" :label="$t('fields.city')" icon="fa fa-location-arrow">
            <form-input v-model="profile_settings.profile.city" name="city" type="text"></form-input>
        </edit-input>

        <div @click="saveAccount" class="general-button">{{ $t('fields.save') }} </div>
    </div>
</template>

<script>
import EditInput from '../EditInput.vue';

export default {
    name: 'AccountTab',

    components: {
        'edit-input': EditInput,
    },

    props: {
	    profile_settings: {
			required: true,
	    },
    },

    data() {
        return {
            gender_options: [
                {
                    name: this.$t('profile.gender_male'),
                    name_clean: "male"
                },
                {
                    name: this.$t('profile.gender_female'),
                    name_clean: "female"
                },
                {
                    name: this.$t('profile.gender_different'),
                    name_clean: "different"
                },
                {
                    name: this.$t('profile.wont_say'),
                    name_clean: "wont_say"
                }
            ],
        }
    },
    methods: {
        saveAccount() {
            this.$emit('saveAccount');
        },

        emitTabChange() {
            this.$emit('changeTab', 'changepassword');
        },
    },
};
</script>
